import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';
// import { FiArrowUp } from 'react-icons/fi';
import { languageStore } from '../../subscriber/Language';
import logo from '../../assets/LUCA_FINAL_LOGO.png';
import moment from 'moment';
import SocialMedia from '../socialMedia';

const Footer = () => {
    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('menus');
    
    // const scrollToTop = useCallback(() => {
    //     // Scroll to top of the page on load
    //     window.scrollTo(0, 0);
    // }, []);

    return (
        <footer className="bg-[#fbe9dd] text-white pt-36 pb-5">
            <div className="container mx-auto px-4">
                {/* Desktop Footer */}
                <div className="hidden lg:flex justify-between mb-20">
                    <div className="w-1/4">
                        {/* <h3 className="text-2xl font-semibold mb-4 text-center">Our Contact</h3>
                        <ul className="text-center text-gray-300">
                            <li className="mb-2">contact@domain.com</li>
                            <li>+62 887-1106-22814</li>
                        </ul> */}
                    </div>
                    <div className="w-1/2 text-center">
                        <img src={logo} alt="Logo" width={240} height={60} className="mx-auto mb-5" />
                        <nav className="mb-5">
                            <Link to={`/`} className="mx-4 text-[#1f0707] hover:text-[#C7702A]">{t?.home}</Link>
                            <Link to={`/about_us`} className="mx-4 text-[#1f0707] hover:text-[#C7702A]">{t?.about}</Link>
                            <Link to={`/blogs`} className="mx-4 text-[#1f0707] hover:text-[#C7702A]">{t?.blog}</Link>
                            <Link to={`/projects`} className="mx-4 text-[#1f0707] hover:text-[#C7702A]">{t?.projects}</Link>
                            <Link to={`/services`} className="mx-4 text-[#1f0707] hover:text-[#C7702A]">{t?.services}</Link>
                            <Link to={`/portfolio`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.portfolio}</Link>
                            <Link to={`/contact_us`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.contactUs}</Link>
                        </nav>
                        <SocialMedia isInline={true} />
                    </div>
                    <div className="w-1/4">
                        {/* <h3 className="text-2xl font-semibold mb-4 text-center">Our Office</h3>
                        <p className="text-center text-gray-300">
                            Tokyo, Japan
                        </p> */}
                    </div>
                </div>

                {/* Mobile Footer */}
                <div className="lg:hidden">
                    {/* ... Mobile footer content (similar structure to desktop, but stacked) ... */}
                    <div className="flex flex-col items-center justify-center mb-5 space-y-6">
                        <div className="w-1/2 text-center">
                            <img src={logo} alt="Logo" width={240} height={60} className="mx-auto mb-5" />
                        </div>
                        <div className="text-center">
                            <nav className="mb-5 flex flex-col items-center space-y-2">
                                <Link to={`/`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.home}</Link>
                                <Link to={`/about_us`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.about}</Link>
                                <Link to={`/blogs`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.blog}</Link>
                                <Link to={`/projects`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.projects}</Link>
                                <Link to={`/services`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.services}</Link>
                                <Link to={`/portfolio`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.portfolio}</Link>
                                <Link to={`/contact_us`} className="mx-2 text-[#1f0707] hover:text-[#C7702A]">{t?.contactUs}</Link>
                            </nav>
                            <SocialMedia isInline={true} />
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-white/30 mt-20 pt-8 text-center relative">
                    <p className="text-gray-400 text-sm">
                        © {moment().format('YYYY')} {t?.powred_by}
                    </p>
                    {/* <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToTop();
                        }}
                        className="absolute right-2 bottom-0 bg-[#D3752B] p-2 rounded-sm transform rotate-0 cursor-pointer"
                    >
                        <FiArrowUp className="text-white" />
                    </a> */}
                </div>
            </div>
        </footer>
    );
};

export default observer(Footer);
